export default function ContactSection() {
  return (
    <section id="contact" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-mail-send-line"></i>
            <span className="whitespace-nowrap">联系我们</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            有资源想分享？欢迎投稿
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-xl mx-auto">
            如果你有好的视频资源或者发现有趣的影视内容，欢迎通过以下方式联系豆花视频团队。
            我们期待与更多美食视频平台合作，共同丰富内容生态。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-50 rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
              <p className="text-xs text-foreground-600">搜索「豆花视频」关注</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">邮件投稿</h3>
              <p className="text-xs text-foreground-600">douhua@example.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                <i className="ri-discuss-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线反馈</h3>
              <p className="text-xs text-foreground-600">点击下方按钮提交建议</p>
            </div>
          </div>

          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-chat-3-line"></i>
            了解更多
          </a>
        </div>
      </div>
    </section>
  );
}